import http from "./httpService";
import { getApiUrl } from "../config";

const apiEndpoint = getApiUrl() + "/RemoteConfig";

export async function getRemoteConfig(): Promise<RemoteConfig> {
    let resp = await http.get<RemoteConfig>(apiEndpoint);
    return resp.data;
}

export async function saveRemoteConfig(config: RemoteConfig) {

    const response = await http.post<any>(apiEndpoint, config);
    return response.data;

};

